import { render } from "./Timetable.vue?vue&type=template&id=3b08ff22&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"

import "./Timetable.vue?vue&type=style&index=0&id=3b08ff22&lang=scss&scoped=true"
import "./Timetable.vue?vue&type=style&index=1&id=3b08ff22&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b08ff22"]])

export default __exports__